export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14936.1a851119.jpg";